import {cloneDeep, get} from "lodash";
import {getNumber, getString} from "Core/helpers/data";
import {SearchPaymentsListItemDataObject} from "../dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {SearchPaymentsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new SearchPaymentsListItemDataObject(
		getString(result, 'id'),
		getNumber(result, 'appointmentsNumber'),
		getNumber(result, 'amount'),
		getNumber(result, 'debtAmount'),
		getNumber(result, 'returnedDebtAmount'),
		getString(result, 'note'),
		getString(result, 'therapyPatientId'),
		getString(result, 'therapyPatientFirstName'),
		getString(result, 'therapyPatientLastName'),
		getString(result, 'officeLocationId'),
		getString(result, 'officeLocationName'),
		getDate(get(result, 'paymentDate'), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S)
	);

	return result;
}

// @note There is no output function since list is read only.